<nz-card class="reflections">
  <h4 class="primary-color mb-0">Riflessioni</h4>

  <ng-container *ngIf="!isEdit"> <hr class="mt-3" /></ng-container>

  <ng-container *ngIf="!isEdit">
    <div *ngIf="dataReflections; else loading">
      <ng-container *ngIf="reflections?.length; else noReflections">
        <div
          #carouselExampleDark
          id="carouselExampleDark"
          class="carousel carousel-dark slide overflow-x-hidden">
          <div class="carousel-inner">
            <!-- Itera sui gruppi di reflections -->
            <div
              *ngFor="let group of groupedReflections; let i = index"
              class="carousel-item p-5"
              [class.active]="i === 0"
              data-bs-interval="10000">
              <div
                class="d-flex justify-content-center align-items-center gap-5 w-100">
                <!-- Itera sui 3 elementi del gruppo -->
                <app-generic-reflection-widget
                  class="z-3"
                  *ngFor="let reflection of group"
                  [userProjects]="userProjects"
                  [onlyShow]="true"
                  [reflection]="reflection"></app-generic-reflection-widget>
              </div>
            </div>
          </div>

          <button
            #prevButton
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleDark"
            data-bs-slide="prev"
            style="left: -50px"
            [hidden]="isFirstSlide">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>

          <button
            #nextButton
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleDark"
            data-bs-slide="next"
            style="right: -50px"
            [hidden]="isLastSlide">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </ng-container>

      <ng-template #noReflections>
        <p class="m-0 p-3 text-center template-empty">
          Nessuna riflessione presente
        </p>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #loading>
    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
  </ng-template>
</nz-card>
